import InputTextarea from './input-textarea';

export default InputTextarea;
